<template>
  <div class="links-container">
    <div class="link">
      <a href="https://arrotex.nostradata.com.au/MicroStrategy/servlet/mstrWeb?Server=PRODMSTR51&Project=Arrotex&Port=0&evt=3140&src=mstrWeb.3140&documentID=BE0294FB43264AE7AAF5009E9F868B8D" target="_blank">Nostra Data</a>
      <ExternalLinkIcon />
    </div>
    <div class="link">
      <a href="https://identity.intellipharm.com.au/login" target="_blank">Intellipharm</a>
      <ExternalLinkIcon />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ExternalLinkIcon } from '../icons'
</script>

<style scoped>
.links-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
}

.link {
  display: flex;
  align-items: center;
  gap: 0.3125rem;
  cursor: pointer;
  font-size: var(--font-size-body);
}

.link:hover {
  opacity: 0.5;
}
</style>
